var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFemaleAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 54,
    viewBox: "0 0 44 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.8823 34.7586H35.046C36.468 34.7586 37.6322 33.5986 37.6322 32.182V17.4599C37.6322 8.95712 30.6494 2 22.115 2C13.5806 2 6.59772 8.95729 6.59772 17.4599V32.182C6.59772 33.5986 7.76187 34.7586 9.18395 34.7586H17.3475",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    strokeMiterlimit: 22.9256
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8276 13.4943C21.8276 16.3949 24.2198 18.7681 27.1437 18.7681H32.4597V25.3604C32.4597 31.1616 27.6752 35.9081 21.8276 35.9081C15.9799 35.9081 11.1954 31.1616 11.1954 25.3604V18.7681H16.5114C19.4353 18.7681 21.8276 16.3949 21.8276 13.4943Z",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    strokeMiterlimit: 22.9256
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3509 34.7586L16.7205 38.7155L8.19747 41.8405C4.99459 43.0147 2 45.9567 2 49.3937V52H33.1848M35.7692 52H42.2299V49.3937C42.2299 45.9577 39.2351 43.0148 36.0324 41.8404L27.5094 38.7155L26.8788 34.7586",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    strokeMiterlimit: 22.9256
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2873 38.7816C27.2873 41.6383 24.9716 43.954 22.1149 43.954C19.2583 43.954 16.9425 41.6383 16.9425 38.7816",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    strokeMiterlimit: 22.9256
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFemaleAlt);
export default __webpack_public_path__ + "static/media/icon-female-alt.b7ff58364f6b2c3e0547a395249cc8dc.svg";
export { ForwardRef as ReactComponent };